import { createSelector } from '@reduxjs/toolkit';
import { selectLocation } from 'shared/selectors/location';

export const selectWithNeighborsOptions = createSelector(selectLocation, currentLocation => {
  let locationName;

  if (currentLocation === 'moscow_mo') {
    locationName = 'Москва и область';
  } else if (currentLocation === 'spb_lo') {
    locationName = 'Санкт-Петербург и область';
  } else {
    locationName = currentLocation.displayName || '';
  }

  return [
    {
      label: locationName,
      value: false,
    },
    { label: `${locationName} + 20км`, value: true },
  ];
});
